// Info: les variables suivantes seront automatiquement remplacées:
// title: {applicantName} (nom du propriétaire)
// cardText: {deposit} (montant de la caution), {minimalDeposit} (montant de la caution minimale) et {depositFees} (montant des frais de sécurisation)
// validate: {total} (montant total de la transaction)

export const messages = {
  fr: {
    helloPage: {
      onlineCheckinPage1: {
        title: "Préparez votre arrivée chez {applicantName}",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        phoneNumber: "Téléphone",
        startDate: "Date d'arrivée",
        endDate: "Date de départ",
        selectDate: "Sélectionnez...",
        next: "Suivant",
      },
      onlineCheckinPage2: {
        pleaseWait: "Patientez ...",
        depositOnly: {
          insuranceFeesOption1: {
            title: "Complétez votre check-in en ligne",
            transactionDetails: "Sécurisez votre séjour",
            notDebitedDeposit: "Caution (sans blocage)",
            securityFees: "Assurance bancaire",
            totalToPay: "Total",
            validate: "Valider ma caution",
            cardTitle: "Assurance bancaire",
            cardText: "Cette assurance non remboursable proposée par notre partenaire bancaire vous évite de bloquer {deposit} sur votre carte. Si vous préférez une option sans frais, vous pouvez bloquer le montant total de votre caution et le récupérer automatiquement 7 jours après votre départ en ",
            doSoHere: "cliquant ici.",
            commitmentTitle: "Protection voyageur",
            commitmentText: "Grâce à la protection safecheckin, un tiers de confiance sécurise vos fonds et garantit qu'aucun prélèvement ne peut être réalisé sans être transparent, justifié et vérifié.",
            securityTitle: "Sécurité bancaire",
            securityText: "Vos informations bancaires sont cryptées selon les derniers standards en vigueur et sont sécurisées chez notre partenaire bancaire. Nous ne sauvegardons, ni ne faisons transiter d'informations bancaires sur nos serveurs.",
          },
          reducedDepositOption2: {
            title: "Complétez votre check-in en ligne",
            transactionDetails: "Sécurisez votre séjour",
            minimalDeposit: "Caution réduite",
            securityFees: "Assurance bancaire",
            totalToPay: "Total",
            validate: "Valider ma caution",
            cardTitle: "Assurance bancaire",
            cardText: "Cette assurance non remboursable proposée par notre partenaire bancaire vous permet de bloquer seulement {minimalDeposit} sur votre carte au lieu de votre caution complète de {deposit}. Si vous préférez une option sans frais, vous pouvez bloquer le montant total de votre caution et le récupérer automatiquement 7 jours après votre départ en ",
            doSoHere: "cliquant ici.",
            commitmentTitle: "Protection voyageur",
            commitmentText: "Grâce à la protection safecheckin, un tiers de confiance sécurise vos fonds et garantit qu'aucun prélèvement ne peut être réalisé sans être transparent, justifié et vérifié.",
            securityTitle: "Sécurité bancaire",
            securityText: "Vos informations bancaires sont cryptées selon les derniers standards en vigueur et sont sécurisées chez notre partenaire bancaire. Nous ne sauvegardons, ni ne faisons transiter d'informations bancaires sur nos serveurs.",
          },
          standardDepositOption3: {
            title: "Complétez votre check-in en ligne",
            transactionDetails: "Sécurisez votre séjour",
            debitedDeposit: "Caution standard",
            securityFees: "Assurance bancaire",
            totalToPay: "Total",
            validate: "Valider ma caution",
            cardTitle: "Caution standard",
            cardText: "Le montant de votre caution est débité puis remboursé automatiquement 7 jours après votre départ. Si vous préférez une option plus flexible, vous pouvez la sélectionner en ",
            doSoHere: "cliquant ici.",
            commitmentTitle: "Protection voyageur",
            commitmentText: "Grâce à la protection safecheckin, un tiers de confiance sécurise vos fonds et garantit qu'aucun prélèvement ne peut être réalisé sans être transparent, justifié et vérifié.",
            securityTitle: "Sécurité bancaire",
            securityText: "Vos informations bancaires sont cryptées selon les derniers standards en vigueur et sont sécurisées chez notre partenaire bancaire. Nous ne sauvegardons, ni ne faisons transiter d'informations bancaires sur nos serveurs.",
          }
        },
        bookingAndDeposit: {
          insuranceFeesOption1: {
            title: "Complétez votre check-in en ligne",
            transactionDetails: "Détails de la réservation",
            bookingAmount: "Montant",
            notDebitedDeposit: "Caution (sans blocage)",
            securityFees: "Frais d'assurance",
            totalToPay: "Total",
            validate: "Valider ma réservation",
            cardTitle: "Frais d'assurance",
            cardText: "Cette assurance non remboursable proposée par notre partenaire bancaire vous évite de bloquer {deposit} sur votre carte. Si vous préférez une option sans frais, vous pouvez bloquer le montant total de votre caution et le récupérer automatiquement 7 jours après votre départ en ",
            doSoHere: "cliquant ici.",
            commitmentTitle: "Protection voyageur",
            commitmentText: "Grâce à la protection safecheckin, un tiers de confiance sécurise vos fonds et garantit qu'aucun prélèvement ne peut être réalisé sans être transparent, vérifié et justifié.",
            securityTitle: "Sécurité bancaire",
            securityText: "Vos informations bancaires sont cryptées selon les derniers standards en vigueur et sont sécurisées chez notre partenaire bancaire. Nous ne sauvegardons, ni ne faisons transiter d'informations bancaires sur nos serveurs.",
          },
          standardDepositOption3: {
            title: "Complétez votre check-in en ligne",
            transactionDetails: "Détails de la réservation",
            bookingAmount: "Montant",
            debitedDeposit: "Caution standard",
            securityFees: "Frais d'assurance",
            totalToPay: "Total",
            validate: "Valider ({total})",
            cardTitle: "Caution standard",
            cardText: "Le montant de votre caution est débité puis remboursé automatiquement 7 jours après votre départ. Si vous préférez une option plus flexible, vous pouvez la sélectionner en ",
            doSoHere: "cliquant ici.",
            commitmentTitle: "Protection voyageur",
            commitmentText: "Grâce à la protection safecheckin, un tiers de confiance sécurise vos fonds et garantit qu'aucun prélèvement ne peut être réalisé sans être transparent, vérifié et justifié.",
            securityTitle: "Sécurité bancaire",
            securityText: "Vos informations bancaires sont cryptées selon les derniers standards en vigueur et sont sécurisées chez notre partenaire bancaire. Nous ne sauvegardons, ni ne faisons transiter d'informations bancaires sur nos serveurs.",
          }
        },
        bookingOnly: {
          title: "Complétez votre check-in en ligne",
          transactionDetails: "Détails de la réservation",
          bookingAmount: "Montant",
          totalToPay: "Total",
          validate: "Valider ma réservation",
          commitmentTitle: "Engagement",
          commitmentText: "En acceptant cette transaction, j'autorise le propriétaire à débiter ma carte bancaire du montant indiqué.",
          securityTitle: "Sécurité bancaire",
          securityText: "Vos informations bancaires sont cryptées selon les derniers standards en vigueur et sont sécurisées chez notre partenaire bancaire. Nous ne sauvegardons, ni ne faisons transiter d'informations bancaires sur nos serveurs.",
        }
      },
    },
    successPage: {
      title: "Caution validée! 🎉",
      subTitle:
        "Envoyez immédiatement le message ci-dessous au propriétaire pour le prévenir, vous pouvez ajuster le message avant de l'envoyer si besoin.",
      subSubTitle:
        "Envoyez le message ci-dessous au propriétaire pour obtenir vos accès :",
      sendSMS: "Envoyer par SMS",
      copy: "Copier le message",
      copied: "Message copié",
      message: "Message",
    },
    errorPage: {
      title: "🔗 Lien de paiement invalide!",
      message:
        "Malheureusement, le lien que vous avez suivi n'est plus fonctionnel. Il est probable que le propriétaire l'ait retiré ou qu'il ait expiré. Nous vous suggérons de contacter votre propriétaire pour obtenir un nouveau lien valide.",
    },
  },
  en: {
    helloPage: {
      onlineCheckinPage1: {
        title: "Prepare your arrival at {applicantName}'s",
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        phoneNumber: "Phone number",
        startDate: "Arrival date",
        endDate: "Departure date",
        selectDate: "Select...",
        next: "Next",
      },
      onlineCheckinPage2: {
        pleaseWait: "Please wait ...",
        depositOnly: {
          insuranceFeesOption1: {
            title: "Complete your online check-in",
            transactionDetails: "Secure your stay",
            notDebitedDeposit: "Security deposit (no hold)",
            securityFees: "Insurance fees",
            totalToPay: "Total",
            validate: "Confirm my deposit",
            cardTitle: "Insurance fees",
            cardText: "This non-refundable insurance offered by our banking partner allows you to avoid a {deposit} hold on your card. If you prefer a fee-free option, you can have the full deposit amount held and automatically released 7 days after your departure by ",
            doSoHere: "clicking here.",
            commitmentTitle: "Traveler protection",
            commitmentText:
              "With safecheckin protection, a trusted third party secures your funds and ensures that no charge can be made without being transparent, substantiated, and verified.",
            securityTitle: "Banking security",
            securityText:
              "Your banking information is encrypted to the latest standards and secured by our banking partner. We do not store or process any banking data on our servers.",
          },
          reducedDepositOption2: {
            title: "Complete your online check-in",
            transactionDetails: "Secure your stay",
            minimalDeposit: "Reduced deposit",
            securityFees: "Insurance fees",
            totalToPay: "Total",
            validate: "Confirm my deposit",
            cardTitle: "Insurance fees",
            cardText: "This non-refundable insurance offered by our banking partner allows you to have only {minimalDeposit} held on your card instead of your full deposit of {deposit}. If you prefer a fee-free option, you can have the full deposit amount held and automatically released 7 days after your departure by ",
            doSoHere: "clicking here.",
            commitmentTitle: "Traveler protection",
            commitmentText:
              "With safecheckin protection, a trusted third party secures your funds and ensures that no charge can be made without being transparent, substantiated, and verified.",
            securityTitle: "Banking security",
            securityText:
              "Your banking information is encrypted to the latest standards and secured by our banking partner. We do not store or process any banking data on our servers.",
          },
          standardDepositOption3: {
            title: "Complete your online check-in",
            transactionDetails: "Secure your stay",
            debitedDeposit: "Standard deposit",
            securityFees: "Insurance fees",
            totalToPay: "Total",
            validate: "Confirm my deposit",
            cardTitle: "Standard deposit",
            cardText: "Your deposit amount is charged and then automatically refunded 7 days after your departure. If you prefer a more flexible option, you can select it by ",
            doSoHere: "clicking here.",
            commitmentTitle: "Traveler protection",
            commitmentText:
              "With safecheckin protection, a trusted third party secures your funds and ensures that no charge can be made without being transparent, substantiated, and verified.",
            securityTitle: "Banking security",
            securityText:
              "Your banking information is encrypted to the latest standards and secured by our banking partner. We do not store or process any banking data on our servers.",
          }
        },
        bookingAndDeposit: {
          insuranceFeesOption1: {
            title: "Complete your online check-in",
            transactionDetails: "Booking details",
            bookingAmount: "Amount of the booking",
            notDebitedDeposit: "Security deposit (no hold)",
            securityFees: "Insurance fees",
            totalToPay: "Total to pay",
            validate: "Validate ({total})",
            cardTitle: "Insurance fees",
            cardText: "This insurance offered by our financial partner avoids you having to block {deposit} on your card. If you prefer a free option, you can block the full amount of your deposit and get it back automatically 7 days after your departure by ",
            doSoHere: "clicking here.",
            commitmentTitle: "Traveler protection",
            commitmentText:
              "With safecheckin protection, a trusted third party secures your funds and ensures that no charge can be made without being transparent, substantiated, and verified.",
            securityTitle: "Banking security",
            securityText:
              "Your banking information is encrypted to the latest standards and secured by our banking partner. We do not store or process any banking data on our servers.",
          },
          standardDepositOption3: {
            title: "Complete your online check-in",
            transactionDetails: "Booking details",
            bookingAmount: "Amount of the booking",
            debitedDeposit: "Standard deposit",
            securityFees: "Insurance fees",
            totalToPay: "Total to pay",
            validate: "Validate ({total})",
            cardTitle: "Standard deposit",
            cardText: "Your deposit amount is debited and then automatically refunded 7 days after your departure. If you prefer a more flexible option, you can select it by ",
            doSoHere: "clicking here.",
            commitmentTitle: "Traveler protection",
            commitmentText:
              "With safecheckin protection, a trusted third party secures your funds and ensures that no charge can be made without being transparent, substantiated, and verified.",
            securityTitle: "Banking security",
            securityText:
              "Your banking information is encrypted to the latest standards and secured by our banking partner. We do not store or process any banking data on our servers.",
          }
        },
        bookingOnly: {
          title: "Complete your online check-in",
          transactionDetails: "Booking details",
          bookingAmount: "Amount of the booking",
          totalToPay: "Total to pay",
          validate: "Validate ({total})",
          commitmentTitle: "Traveler protection",
          commitmentText:
            "With safecheckin protection, a trusted third party secures your funds and ensures that no charge can be made without being transparent, substantiated, and verified.",
          securityTitle: "Banking security",
          securityText:
            "Your banking information is encrypted to the latest standards and secured by our banking partner. We do not store or process any banking data on our servers.",
        }
      },
    },
    successPage: {
      title: "Congratulations, your transaction is complete! ",
      subTitle:
        "Send the message below to the owner immediately to notify them, you can adjust the message before sending it if needed.",
      subSubTitle: "Send the message below to the owner immediately.",
      sendSMS: "Send by SMS",
      copy: "Copy the message",
      copied: "Copied",
      message: "Message",
    },
    errorPage: {
      title: "🔗 Invalid payment link!",
      message:
        "Unfortunately, the link you followed is no longer functional. It is likely that the owner has removed it or it has expired. We suggest you contact your owner to obtain a new valid link.",
    },
  },
  es: {
    helloPage: {
      onlineCheckinPage1: {
        title: "Complete su registro con {applicantName}",
        firstName: "Nombre",
        lastName: "Apellido",
        email: "Email",
        phoneNumber: "Número de teléfono",
        startDate: "Fecha de llegada",
        endDate: "Fecha de salida",
        selectDate: "Seleccionar...",
        next: "Siguiente",
      },
      onlineCheckinPage2: {
        pleaseWait: "Espere por favor ...",
        depositOnly: {
          insuranceFeesOption1: {
            title: "Complete su registro con {applicantName}",
            transactionDetails: "Detalles de la transacción",
            notDebitedDeposit: "Fianza (sin bloqueo)",
            securityFees: "Gastos de seguro",
            totalToPay: "Total a pagar",
            validate: "Validar ({total})",
            cardTitle: "Gastos de seguro",
            cardText: "Este seguro ofrecido por nuestro socio financiero evita que tenga que bloquear {deposit} en su tarjeta. Si prefiere una opción gratuita, puede bloquear el importe total de su fianza y recuperarlo automáticamente 7 días después de su salida haciendo ",
            doSoHere: "clic aquí.",
            commitmentTitle: "Compromiso",
            commitmentText:
              "Al aceptar esta transaction, autorizo al propietario a cargar mi tarjeta de crédito por el monto indicado en caso de cualquier incumplimiento de mi compromiso durante la estancia. Yeswebook garantiza su protección y supervisa la legitimidad de los cargos.",
            securityTitle: "Seguridad bancaria",
            securityText:
              "La información bancaria está encriptada según los últimos estándares vigentes y se asegura con nuestro socio bancario. No almacenamos ni transmitimos ninguna información bancaria en nuestros servidores.",
          },
          reducedDepositOption2: {
            title: "Complete su registro con {applicantName}",
            transactionDetails: "Detalles de la transacción",
            minimalDeposit: "Depósito mínimo",
            securityFees: "Gastos de seguro",
            totalToPay: "Total a pagar",
            validate: "Validar ({total})",
            cardTitle: "Gastos de seguro",
            cardText: "Este seguro ofrecido por nuestro socio financiero le permite bloquear solo {minimalDeposit} en su tarjeta en lugar de su fianza completa de {deposit}. Si prefiere una opción gratuita, puede bloquear el importe total de su fianza y recuperarlo automáticamente 7 días después de su salida haciendo ",
            doSoHere: "clic aquí.",
            commitmentTitle: "Compromiso",
            commitmentText:
              "Al aceptar esta transaction, autorizo al propietario a cargar mi tarjeta de crédito por el monto indicado en caso de cualquier incumplimiento de mi compromiso durante la estancia. Yeswebook garantiza su protección y supervisa la legitimidad de los cargos.",
            securityTitle: "Seguridad bancaria",
            securityText:
              "La información bancaria está encriptada según los últimos estándares vigentes y se asegura con nuestro socio bancario. No almacenamos ni transmitimos ninguna información bancaria en nuestros servidores.",
          },
          standardDepositOption3: {
            title: "Complete su registro con {applicantName}",
            transactionDetails: "Detalles de la transacción",
            debitedDeposit: "Fianza estándar",
            securityFees: "Gastos de seguro",
            totalToPay: "Total a pagar",
            validate: "Validar ({total})",
            cardTitle: "Fianza estándar",
            cardText: "El importe de su fianza se carga y luego se reembolsa automáticamente 7 días después de su salida. Si prefiere una opción más flexible, puede seleccionarla ",
            doSoHere: "clic aquí.",
            commitmentTitle: "Compromiso",
            commitmentText:
              "Al aceptar esta transaction, autorizo al propietario a cargar mi tarjeta de crédito por el monto indicado en caso de cualquier incumplimiento de mi compromiso durante la estancia. Yeswebook garantiza su protección y supervisa la legitimidad de los cargos.",
            securityTitle: "Seguridad bancaria",
            securityText:
              "La información bancaria está encriptada según los últimos estándares vigentes y se asegura con nuestro socio bancario. No almacenamos ni transmitimos ninguna información bancaria en nuestros servidores.",
          }
        },
        bookingAndDeposit: {
          insuranceFeesOption1: {
            title: "Complete su registro con {applicantName}",
            transactionDetails: "Detalles de la transacción",
            bookingAmount: "Importe de la reserva",
            notDebitedDeposit: "Fianza (sin bloqueo)",
            securityFees: "Gastos de seguro",
            totalToPay: "Total a pagar",
            validate: "Validar ({total})",
            cardTitle: "Gastos de seguro",
            cardText: "Este seguro ofrecido por nuestro socio financiero evita que tenga que bloquear {deposit} en su tarjeta. Si prefiere una opción gratuita, puede bloquear el importe total de su fianza y recuperarlo automáticamente 7 días después de su salida haciendo ",
            doSoHere: "clic aquí.",
            commitmentTitle: "Compromiso",
            commitmentText:
              "Al aceptar esta transaction, autorizo al propietario a cargar mi tarjeta de crédito por el monto indicado en caso de cualquier incumplimiento de mi compromiso durante la estancia. Yeswebook garantiza su protección y supervisa la legitimidad de los cargos.",
            securityTitle: "Seguridad bancaria",
            securityText:
              "La información bancaria está encriptada según los últimos estándares vigentes y se asegura con nuestro socio bancario. No almacenamos ni transmitimos ninguna información bancaria en nuestros servidores.",
          },
          standardDepositOption3: {
            title: "Complete su registro con {applicantName}",
            transactionDetails: "Detalles de la transacción",
            bookingAmount: "Importe de la reserva",
            debitedDeposit: "Fianza estándar",
            securityFees: "Gastos de seguro",
            totalToPay: "Total a pagar",
            validate: "Validar ({total})",
            cardTitle: "Fianza estándar",
            cardText: "El importe de su fianza se carga y luego se reembolsa automáticamente 7 días después de su salida. Si prefiere una opción más flexible, puede seleccionarla ",
            doSoHere: "clic aquí.",
            commitmentTitle: "Compromiso",
            commitmentText:
              "Al aceptar esta transaction, autorizo al propietario a cargar mi tarjeta de crédito por el monto indicado en caso de cualquier incumplimiento de mi compromiso durante la estancia. Yeswebook garantiza su protección y supervisa la legitimidad de los cargos.",
            securityTitle: "Seguridad bancaria",
            securityText:
              "La información bancaria está encriptada según los últimos estándares vigentes y se asegura con nuestro socio bancario. No almacenamos ni transmitimos ninguna información bancaria en nuestros servidores.",
          }
        },
        bookingOnly: {
          title: "Complete su registro con {applicantName}",
          transactionDetails: "Detalles de la transacción",
          bookingAmount: "Importe de la reserva",
          totalToPay: "Total a pagar",
          validate: "Validar ({total})",
          commitmentTitle: "Compromiso",
          commitmentText:
            "Al aceptar esta transaction, autorizo al propietario a cargar mi tarjeta de crédito por el monto indicado en caso de cualquier incumplimiento de mi compromiso durante la estancia. Yeswebook garantiza su protección y supervisa la legitimidad de los cargos.",
          securityTitle: "Seguridad bancaria",
          securityText:
            "La información bancaria está encriptada según los últimos estándares vigentes y se asegura con nuestro socio bancario. No almacenamos ni transmitimos ninguna información bancaria en nuestros servidores.",
        }
      },
    },
    successPage: {
      title: "¡Enhorabuena, tu transacción se ha completado!",
      subTitle:
        "Envía inmediatamente el siguiente mensaje al propietario para hacérselo saber, puedes ajustar el mensaje antes de enviarlo si es necesario.",
      subSubTitle: "Envíe el siguiente mensaje al propietario de inmediato.",
      sendSMS: "Enviar por SMS",
      copy: "Copiar el mensaje",
      copied: "Mensaje copiado",
      message: "Mensage",
    },
    errorPage: {
      title: "🔗 ¡Enlace de pago no válido!",
      message:
        "Lamentablemente, el enlace que siguió ya no es funcional. Es probable que el propietario lo haya eliminado o que haya caducado. Le sugerimos que se ponga en contacto con su propietario para obtener un nuevo enlace válido.",
    },
  },
};
